<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='gift_name'>
      <a-input v-model:value="search.gift_name" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <!-- <a-form-item label="商品分类" name='type_id'>
      <a-select v-model:value="search.type_id" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="shanghai">正常</a-select-option>
        <a-select-option value="beijing">禁用</a-select-option>
      </a-select>
    </a-form-item> -->
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
            style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>{{record.gift_name}}</template>
      </a-card-meta>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :ghost="!record.select" v-if='!checkout'>{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getGift } from "@/api/product";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    gift_name: "",
    page: 1,
    limit: 5
  };
  export default {
    name: "selectGiftLibrary",
    components: {},
    props: {
      selectList: {
        type: Array
      },
      checkout: {
        type: Boolean
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 1,
        selectList: [],
        checkout: false,
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },

        {
          title: "礼品信息",
          dataIndex: "info",
          key: "info",
          slots: { customRender: "info" },
        },
        {
          title: "礼品库分类",
          dataIndex: "age",
          key: "age",
          customRender: ({ record }) => {
            return record.category.group_name ? record.category.group_name : '未分类'
          }
        },
        {
          title: "价格/元",
          dataIndex: "market_price",
          key: "market_price",
        },
        {
          title: "库存",
          dataIndex: "stock_num",
          key: "stock_num",
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getGift(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            if (props.selectList.length > 0) {
              data.value.forEach(i => {
                if (props.selectList.find(v => i.id == v.id)) {
                  i.select = true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm
      };
    },
  };
</script>